import React, { useEffect, useState } from "react";

function App() {
const heroImages = ["/visen-bg-1.jpg", "/visen-bg-2.jpg"];
const [currentImage, setCurrentImage] = useState(0);
const isMobile = window.innerWidth < 768;

useEffect(() => {
const interval = setInterval(() => {
setCurrentImage((prev) => (prev + 1) % heroImages.length);
}, 3000);

return () => clearInterval(interval);

}, [heroImages.length]);

const services = [
{
title: "DOOH Advertising",
description:
"High-impact digital out-of-home campaigns designed to elevate brand visibility across premium screens and strategic placements.",
},
{
title: "Outdoor Media",
description:
"Billboards, signage, and large-format media solutions that put your brand in front of the right audience.",
},
{
title: "Creative Campaigns",
description:
"Strong concepts, premium visuals, and brand-focused execution tailored for modern advertising.",
},
];

const stats = [
{ value: "Premium", label: "Brand Positioning" },
{ value: "DOOH", label: "Core Focus" },
{ value: "UAE", label: "Market Presence" },
];

return (
<div
style={{
margin: 0,
fontFamily:
'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
backgroundColor: "#050505",
color: "#ffffff",
}}
>
<section
style={{
minHeight: "100vh",
backgroundImage: `linear-gradient(rgba(0,0,0,0.48), rgba(0,0,0,0.62)), url(${heroImages[currentImage]})`,
backgroundSize: "cover",
backgroundPosition: "center",
display: "flex",
alignItems: "flex-end",
justifyContent: "center",
textAlign: "center",
padding: isMobile ? "0 15px 60px" : "0 20px 80px",
}}
>
<div style={{ maxWidth: "1100px", width: "100%" }}>
<p
style={{
letterSpacing: isMobile ? "0.16em" : "0.24em",
fontSize: isMobile ? "10px" : "12px",
marginBottom: "18px",
color: "rgba(255,255,255,0.78)",
}}
>
DOOH · OUTDOOR · ADVERTISING </p>

      <h1
        style={{
          fontSize: isMobile ? "42px" : "90px",
          lineHeight: 1,
          margin: "0 0 20px",
          fontWeight: 800,
        }}
      >
        VISEN Advertising
      </h1>

      <p
        style={{
          fontSize: isMobile ? "18px" : "30px",
          color: "rgba(255,255,255,0.88)",
          margin: "0 auto 34px",
          maxWidth: "820px",
          lineHeight: 1.6,
        }}
      >
        Premium Outdoor & Digital Advertising Solutions
      </p>

      <div
        style={{
          display: "flex",
          gap: "16px",
          justifyContent: "center",
          flexWrap: "wrap",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
        }}
      >
        <a
          href="#services"
          style={{
            background: "#ffffff",
            color: "#111111",
            textDecoration: "none",
            padding: "16px 28px",
            borderRadius: "999px",
            fontWeight: 700,
            fontSize: "15px",
            minWidth: isMobile ? "220px" : "unset",
          }}
        >
          Explore Services
        </a>

        <a
          href="#contact"
          style={{
            background: "transparent",
            color: "#ffffff",
            textDecoration: "none",
            padding: "16px 28px",
            borderRadius: "999px",
            fontWeight: 700,
            fontSize: "15px",
            border: "1px solid rgba(255,255,255,0.45)",
            minWidth: isMobile ? "220px" : "unset",
          }}
        >
          Contact VISEN
        </a>
      </div>
    </div>
  </section>

  <section
    style={{
      background: "#0a0a0a",
      borderTop: "1px solid rgba(255,255,255,0.08)",
      borderBottom: "1px solid rgba(255,255,255,0.08)",
    }}
  >
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "28px 20px",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "20px",
      }}
    >
      {stats.map((item) => (
        <div
          key={item.label}
          style={{
            background: "rgba(255,255,255,0.03)",
            padding: "24px",
            borderRadius: "20px",
            textAlign: "center",
            border: "1px solid rgba(255,255,255,0.06)",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: 800 }}>{item.value}</div>
          <div style={{ color: "rgba(255,255,255,0.68)", marginTop: "8px" }}>
            {item.label}
          </div>
        </div>
      ))}
    </div>
  </section>

  <section style={{ padding: isMobile ? "70px 15px" : "90px 20px", background: "#050505" }}>
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(320px, 1fr))",
        gap: "32px",
        alignItems: "center",
      }}
    >
      <div>
        <p
          style={{
            color: "#ff5a4f",
            textTransform: "uppercase",
            letterSpacing: "0.18em",
            fontSize: "13px",
            marginBottom: "14px",
          }}
        >
          About VISEN
        </p>
        <h2
          style={{
            fontSize: isMobile ? "32px" : "52px",
            margin: "0 0 18px",
          }}
        >
          A bold identity for modern advertising.
        </h2>
        <p
          style={{
            color: "rgba(255,255,255,0.74)",
            fontSize: isMobile ? "16px" : "18px",
            lineHeight: 1.8,
            margin: 0,
          }}
        >
          VISEN is built to present brands with impact. From DOOH campaigns to
          outdoor media execution, we create strong visual presence, premium
          perception, and modern advertising experiences that stand out.
        </p>
      </div>

      <div
        style={{
          background:
            "linear-gradient(180deg, rgba(255,90,79,0.18), rgba(255,255,255,0.04))",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: "28px",
          padding: "34px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
      >
        <div
          style={{
            fontSize: "14px",
            color: "rgba(255,255,255,0.6)",
            marginBottom: "14px",
          }}
        >
          Why this landing page works
        </div>
        <ul style={{ margin: 0, paddingLeft: "20px", color: "#ffffff", lineHeight: 2 }}>
          <li>Strong first impression with branded hero image</li>
          <li>Clean premium layout suitable for client presentations</li>
          <li>Clear positioning for DOOH and outdoor advertising</li>
          <li>Easy to expand later into a full company website</li>
        </ul>
      </div>
    </div>
  </section>

  <section
    id="services"
    style={{ padding: isMobile ? "70px 15px" : "90px 20px", background: "#0b0b0b" }}
  >
    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
      <div style={{ textAlign: "center", marginBottom: "46px" }}>
        <p
          style={{
            color: "#ff5a4f",
            textTransform: "uppercase",
            letterSpacing: "0.18em",
            fontSize: "13px",
            marginBottom: "14px",
          }}
        >
          Services
        </p>
        <h2
          style={{
            fontSize: isMobile ? "32px" : "52px",
            margin: 0,
          }}
        >
          What VISEN offers
        </h2>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "1fr"
            : "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "24px",
        }}
      >
        {services.map((service) => (
          <div
            key={service.title}
            style={{
              background: "#111111",
              borderRadius: "26px",
              padding: "30px",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
            }}
          >
            <h3 style={{ fontSize: "24px", marginTop: 0, marginBottom: "14px" }}>
              {service.title}
            </h3>
            <p
              style={{
                color: "rgba(255,255,255,0.72)",
                lineHeight: 1.8,
                margin: 0,
                fontSize: "16px",
              }}
            >
              {service.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>

  <section
    id="contact"
    style={{ padding: isMobile ? "70px 15px" : "90px 20px", background: "#050505" }}
  >
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        background: "linear-gradient(135deg, #1a1a1a, #090909)",
        borderRadius: "34px",
        padding: isMobile ? "28px" : "40px",
        border: "1px solid rgba(255,255,255,0.08)",
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "30px",
        alignItems: "center",
      }}
    >
      <div>
        <p
          style={{
            color: "#ff5a4f",
            textTransform: "uppercase",
            letterSpacing: "0.18em",
            fontSize: "13px",
            marginBottom: "14px",
          }}
        >
          Contact
        </p>
        <h2
          style={{
            fontSize: isMobile ? "30px" : "46px",
            margin: "0 0 14px",
          }}
        >
          Ready to build visibility for your brand?
        </h2>
        <p style={{ color: "rgba(255,255,255,0.72)", lineHeight: 1.8, margin: 0 }}>
          This section can later include your real phone number, WhatsApp, location,
          and a contact form for direct lead generation.
        </p>
      </div>

      <div
        style={{
          background: "rgba(255,255,255,0.03)",
          borderRadius: "24px",
          padding: "26px",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <div style={{ marginBottom: "16px" }}>
          <div
            style={{
              color: "rgba(255,255,255,0.56)",
              fontSize: "13px",
              marginBottom: "6px",
            }}
          >
            Company
          </div>
          <div style={{ fontSize: "18px", fontWeight: 700 }}>VISEN</div>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <div
            style={{
              color: "rgba(255,255,255,0.56)",
              fontSize: "13px",
              marginBottom: "6px",
            }}
          >
            Email
          </div>
          <div style={{ fontSize: "18px", fontWeight: 700 }}>info@visen.ae</div>
        </div>

        <a
          href="mailto:info@visen.ae"
          style={{
            display: "inline-block",
            marginTop: "8px",
            background: "#ffffff",
            color: "#111111",
            textDecoration: "none",
            padding: "14px 24px",
            borderRadius: "999px",
            fontWeight: 700,
          }}
        >
          Email VISEN
        </a>
      </div>
    </div>
  </section>
</div>
);
}

export default App;
